// @flow
import * as React from 'react';

const PATH_D =
  'M0 111c0 47 29.3 87.2 70.6 103.4-1-8.8-2-22.3.3-32l13-55s-3.4-6.7-3.4-16.5c0-15.6 9-27 20-27 9.6 0 14.2 7 14.2 15.5 0 9.6-6 23.8-9.2 37-2.7 11 5.5 20 16.4 20 19.7 0 35-20.7 35-50.8 0-26.5-19.2-45-46.5-45-31.5 0-50 23.6-50 48 0 9.6 3.6 19.8 8.2 25.4 1 1.2 1 2 .7 3.3l-3 12.5c-.5 2-1.6 2.5-3.8 1.5-13.8-6.4-22.5-26.7-22.5-43 0-35 25.6-67 73.5-67 38.5 0 68.4 27.3 68.4 64 0 38.2-24.2 69-57.7 69-11.3 0-21.8-5.8-25.4-12.7L92 188c-2.6 9.6-9.3 21.7-14 29 10.5 3.3 21.6 5 33 5 61.3 0 111-49.7 111-111S172.3 0 111 0 0 49.7 0 111z';
const PATH_FILL = '#e60023';
const VIEW_BOX = '0 0 222 222';

function pinterestLogoSvgString(size?: number, offset?: number) {
  const w = size || 222;
  const h = size || 222;
  const x = offset || 0;
  const y = offset || 0;
  return `
  <svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" x="${x}" y="${y}" viewBox="${VIEW_BOX}">
    <path d="${PATH_D}" fill="${PATH_FILL}" fill-rule="evenodd" />
  </svg>`;
}

export function pinterestLogoSvgDataURL() {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(pinterestLogoSvgString().trim())}`;
}

export default function PinterestLogoSvg({ size }: { size: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox={VIEW_BOX}>
      <path d={PATH_D} fill={PATH_FILL} fillRule="evenodd" />
    </svg>
  );
}
